import Axios from "axios";
import fullScreenLoadingStore from "component/layout/loading/fullscreen";
import nativeBridge from "data/source/native/nativeBridge";
import Request, { RequestResponse } from "data/source/Request";
import * as urlJoin from "url-join";
import Strings from "wasabi-common/lib/types/Strings";
import UrlUtil from "wasabi-common/lib/util/UrlUtil";

export function normalizeUrl(uriComponent: string): string {
  if (uriComponent?.startsWith("data:")) {
    return uriComponent;
  }
  const hostName = window.location.hostname;
  const localChecksBacked = false;

  if (hostName.includes("tvm.media") || hostName.includes("localhost") || hostName.includes("192.168.1.155")) {
    switch (hostName) {
      case "staging-ui.tvm.media":
        return `https://storage.googleapis.com/tvm-media-app.appspot.com/staging/${uriComponent}`;
      case "app.tvm.media":
        return `https://storage.googleapis.com/tvm-media-app.appspot.com/production/${uriComponent}`;
      case "localhost":
        if (localChecksBacked) {
          return normalizeUrlBackend(uriComponent);
        }
      default:
        return `https://storage.googleapis.com/tvm-media-app.appspot.com/production/${uriComponent}`;
    }
  }
  return normalizeUrlBackend(uriComponent);
}

export function normalizeUrlWithoutCache(uriComponent: string): string {
  const hostName = window.location.hostname;

  if (hostName.includes("tvm.media") || hostName.includes("localhost")) {
    switch (hostName) {
      case "staging-ui.tvm.media":
        return `https://storage.googleapis.com/tvm-media-app.appspot.com/staging/${uriComponent}?t=${new Date().getTime()}`;
      case "app.tvm.media":
        return `https://storage.googleapis.com/tvm-media-app.appspot.com/production/${uriComponent}?t=${new Date().getTime()}`;
      default:
        return `https://storage.googleapis.com/tvm-media-app.appspot.com/production/${uriComponent}?t=${new Date().getTime()}`;
    }
  }
  return normalizeUrlBackend(uriComponent);
}

export function normalizeUrlForPost(uriComponent: string): string {
  const baseURL = Axios.defaults.baseURL;
  if (uriComponent && !(Strings.startsWith(uriComponent, "http:") || Strings.startsWith(uriComponent, "https:")) && baseURL) {
    return urlJoin(baseURL, uriComponent);
  }
  return uriComponent;
}

export function normalizeUrlBackend(uriComponent: string): string {
  // const hostName = window.location.hostname;
  // if (hostName === 'localhost') {
  //     return normalizeUrl(uriComponent);
  // }
  let url = `/assets/get?name=${encodeURIComponent(uriComponent)}`;
  const baseURL = Axios.defaults.baseURL;
  if (url && !(Strings.startsWith(url, "http:") || Strings.startsWith(url, "https:")) && baseURL) {
    url = urlJoin(baseURL, url);
    return url;
  }
  return url;
}

export function getParameterByName(paramName: string) {
  const url = window.location.href;
  const name = paramName.replace(/[\[\]]/g, "\\$&");
  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function parseSearchParams() {
  const params = UrlUtil.parseQueries(location.search);
  const parsedHash = UrlUtil.parseHash(location.hash) || ({} as any);
  return {
    ...params,
    ...parsedHash.queries,
  };
}

export function updateQueryString(key: string, value: string) {
  let url = window.location.href;
  if (!url.endsWith("/")) {
    url += "/";
  }
  const re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi");

  if (re.test(url)) {
    if (typeof value !== "undefined" && value !== null) {
      return url.replace(re, "$1" + key + "=" + value + "$2$3");
    }
  }
  if (typeof value !== "undefined" && value !== null) {
    return `${url}?${key}=${encodeURIComponent(value)}`;
  }
  return url;
}

export function parseQuery(queryString: string) {
  const query = {} as any;
  const pairs = (queryString[0] === "?" ? queryString.substr(1) : queryString).split("&");
  for (let i = 0; i < pairs.length; i = i + 1) {
    const pair = pairs[i].split("=");
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
  }
  return query;
}

export function downloadImage(downloadUrl: string, normalize: boolean = true): Promise<any> {
  const link = normalize ? normalizeUrl(downloadUrl) : downloadUrl;
  nativeBridge.openExternalUrl(link);
  fullScreenLoadingStore.setLoading(true);

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      fullScreenLoadingStore.setLoading(false);
      resolve(null);
    }, 500);
  });
}

export async function uploadAndGet(value: string | Blob, fileName?: string) {
  const formData = new FormData();
  formData.append("file", value, fileName);

  const config = Request.getConfig({ method: "POST" }, formData, "assets");

  const response = (await Axios(config)) as RequestResponse<string>;
  if (response.data.result === "ok") {
    return {
      result: "ok",
      data: response.data.data,
    };
  }

  return {
    result: "fail",
    data: null,
  };
}
